module.exports = ".operate-btn {\n  margin-left: 30px;\n}\n"